const lengthLimiter = (title) => {
  if (title?.length > 50) {
    return title.substring(0, 47) + '...'
  } else {
    return title
  }
}

const siteFormatter = (site) => {
  return site.replaceAll(' ', '')
}

export { lengthLimiter, siteFormatter }
